import { ImageEdgesFragment } from '../../album-query.graphql';

type ImageNode = NonNullable<NonNullable<ImageEdgesFragment['edges'][0]>['node']>;

export interface GridItem extends ImageNode {
    id: string;
    src: string;
    srcSet: string;
    width: number;
    height: number;
    index: number;
    likesCount: number;
    commentCount: number;
}

const WRAP_WIDTH = 1110;
const MARGIN = 5;

export const calculateImageGrid = (images: ImageEdgesFragment, wrapWidth: number = WRAP_WIDTH) => {
    const grid: GridItem[][] = [];
    let row: GridItem[] = [];

    if (!images || !images.edges) {
        return grid;
    }

    let rowWidth = 0;
    images.edges.forEach((edge, index) => {
        if (
            edge &&
            edge.node &&
            edge.node.photoFile &&
            edge.node.photoFile.versionsStored &&
            edge.node.photoFile.versionsStored[0]
        ) {
            const { likesCount, commentCount } = edge.node;
            const { src, srcset, versionsStored } = edge.node.photoFile;
            let { width, height } = edge.node.photoFile;
            const version = versionsStored[0]!;
            width = version.width;
            height = version.height;

            if (src && srcset && height && width) {
                const nextRowWidth = rowWidth + width + MARGIN;
                const currentError = Math.abs(wrapWidth - rowWidth);
                const nextError = Math.abs(wrapWidth - nextRowWidth);

                if (currentError < nextError) {
                    adjustRow(row, wrapWidth);
                    grid.push(row);
                    row = [];
                    rowWidth = 0;
                }

                row.push({
                    ...edge.node,
                    id: edge.node.id,
                    src,
                    srcSet: srcset,
                    width,
                    height,
                    index,
                    likesCount: likesCount || 0,
                    commentCount: commentCount || 0,
                });
                rowWidth += width + MARGIN;
            }
        }
    });

    if (row.length) {
        adjustRow(row, wrapWidth, false);
        grid.push(row);
    }
    return grid;
};

const adjustRow = (row: GridItem[], wrapWidth: number = WRAP_WIDTH, enlarge: boolean = true) => {
    const reducer = (accumulator: number, currentValue: GridItem) => accumulator + currentValue.width + MARGIN;
    const rowLength = row.reduce(reducer, 0);

    if (!enlarge && rowLength <= wrapWidth) {
        return;
    }

    if (rowLength !== wrapWidth) {
        const availableWidth = wrapWidth - row.length * MARGIN;
        const realWidth = rowLength - row.length * MARGIN;
        const ratio = availableWidth / realWidth;

        for (let i = 0; i < row.length; i++) {
            row[i] = {
                ...row[i],
                height: row[i].height * ratio,
                width: row[i].width * ratio,
            };
        }
    }
};
